(() => {
  if (window.vvbEditorialInstalled) return;
  window.vvbEditorialInstalled = true;
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const panels = [...root.querySelectorAll('[data-vse-panel]')];
    const tabs = [...root.querySelectorAll('[data-vse-tab]')];
    if (!panels.length || panels.length !== tabs.length) return;
    const abort = new AbortController();
    const listen = (node, name, handler) => node.addEventListener(name, handler, { signal: abort.signal });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const play = root.querySelector('[data-vse-play]');
    const counter = root.querySelector('[data-vse-counter]');
    let current = 0, timer = null, inView = false, hovering = false, editing = false;
    let userPaused = reduced.matches || Boolean(window.Shopify?.designMode);
    const auto = root.dataset.autoplay === 'true';
    const stop = () => { clearTimeout(timer); timer = null; };
    function schedule() {
      stop();
      const canRun = auto && !userPaused && !reduced.matches && !editing;
      if (play) {
        play.setAttribute('aria-pressed', String(userPaused));
        play.setAttribute('aria-label', userPaused ? (play.dataset.labelStart || 'Start automatic rotation') : (play.dataset.labelPause || 'Pause automatic rotation'));
        play.innerHTML = `<span aria-hidden="true">${userPaused ? '▶' : 'Ⅱ'}</span>`;
      }
      if (canRun && panels.length > 1 && inView && !hovering && !document.hidden && !root.contains(document.activeElement)) {
        timer = setTimeout(() => select(current + 1), Math.max(5000, Number(root.dataset.interval) || 7000));
      }
    }
    function select(index, manual = false, focus = false) {
      current = (index + panels.length) % panels.length;
      if (manual) userPaused = true;
      panels.forEach((panel, i) => { panel.hidden = i !== current; });
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === current));
        tab.tabIndex = i === current ? 0 : -1;
      });
      if (counter) counter.textContent = `${String(current + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')}`;
      if (focus) tabs[current].focus({ preventScroll: true });
      if (manual && root.classList.contains('vse-lines') && window.matchMedia('(max-width:760px)').matches) {
        const rail = tabs[current].parentElement;
        rail.scrollTo({ left: tabs[current].offsetLeft - rail.offsetLeft - (rail.clientWidth - tabs[current].clientWidth) / 2,
          behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      schedule();
    }
    listen(root, 'click', (event) => {
      const tab = event.target.closest('[data-vse-tab]');
      if (tab && root.contains(tab)) select(tabs.indexOf(tab), true);
      if (event.target.closest('[data-vse-prev]')) select(current - 1, true);
      if (event.target.closest('[data-vse-next]')) select(current + 1, true);
      if (event.target.closest('[data-vse-play]')) { userPaused = !userPaused; schedule(); }
    });
    listen(root, 'keydown', (event) => {
      if (!event.target.closest('[data-vse-tab]')) return;
      let index;
      if (['ArrowRight', 'ArrowDown'].includes(event.key)) index = current + 1;
      if (['ArrowLeft', 'ArrowUp'].includes(event.key)) index = current - 1;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = panels.length - 1;
      if (index !== undefined) { event.preventDefault(); select(index, true, true); }
    });
    // line photo on mouse-over: pointing at a line tab opens that line and shows its live photo; a tap on the photo toggles it
    if (root.classList.contains('vse-lines')) {
      const peek = (on) => panels.forEach((p, i) => p.classList.toggle('is-peek', on && i === current));
      tabs.forEach((tab, i) => {
        listen(tab, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { if (i !== current) select(i); peek(true); } });
        listen(tab, 'pointerleave', (event) => { if (event.pointerType === 'mouse') peek(false); });
      });
      listen(root, 'click', (event) => {
        const fig = event.target.closest('.vse-line-photo.has-alt');
        if (fig) fig.closest('[data-vse-panel]').classList.toggle('is-peek');
      });
    }
    listen(root, 'pointerenter', (event) => { if (event.pointerType !== 'touch') { hovering = true; schedule(); } });
    listen(root, 'pointerleave', () => { hovering = false; schedule(); });
    listen(root, 'focusin', schedule);
    listen(root, 'focusout', () => queueMicrotask(schedule));
    listen(document, 'visibilitychange', schedule);
    listen(reduced, 'change', () => { if (reduced.matches) userPaused = true; schedule(); });
    const observer = new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; schedule(); }, { threshold: .05 });
    observer.observe(root);
    root.classList.add('vse-ready');
    select(0);
    instances.set(root, { select, block(event) { editing = true; const i = panels.findIndex(p => p.dataset.blockId === event.detail.blockId); if (i >= 0) select(i); },
      deselect() { editing = false; schedule(); }, destroy() { stop(); observer.disconnect(); abort.abort(); instances.delete(root); } });
  }
  const initAll = (scope = document) => scope.querySelectorAll('[data-vse-slider]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true }); else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-vse-slider]').forEach(root => instances.get(root)?.destroy()));
  document.addEventListener('shopify:block:select', event => { for (const [root, state] of instances) if (root.dataset.sectionId === event.detail.sectionId) state.block(event); });
  document.addEventListener('shopify:block:deselect', event => { for (const [root, state] of instances) if (root.dataset.sectionId === event.detail.sectionId) state.deselect(); });
})();
